import { render, staticRenderFns } from "./application-create-headline.vue?vue&type=template&id=2ec0ad88&scoped=true&"
import script from "./application-create-headline.vue?vue&type=script&lang=js&"
export * from "./application-create-headline.vue?vue&type=script&lang=js&"
import style0 from "./application-create-headline.vue?vue&type=style&index=0&id=2ec0ad88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0ad88",
  null
  
)

export default component.exports